import React, { type FC, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { AppRoutes } from "@domain/routing/routeConstants";
import { AvmPaths } from "@accounting/avm/paths";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleAVMLinks: FC = () => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: `${AppRoutes.avm}`,
                to: `${AppRoutes.avm}`,
                label: <FormattedMessage id="avm.nav.dashboard" />,
                end: true,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.ASSETS}`,
                to: `${AppRoutes.avm}/${AvmPaths.ASSETS}`,
                label: <FormattedMessage id="avm.nav.assets" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.MOVEMENTS}`,
                to: `${AppRoutes.avm}/${AvmPaths.MOVEMENTS}`,
                label: <FormattedMessage id="avm.nav.movements" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.IMPORT}`,
                to: `${AppRoutes.avm}/${AvmPaths.IMPORT}`,
                label: <FormattedMessage id="avm.nav.import" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.RESTWERT}`,
                to: `${AppRoutes.avm}/${AvmPaths.RESTWERT}`,
                label: <FormattedMessage id="avm.nav.restwert" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.SPIEGEL}`,
                to: `${AppRoutes.avm}/${AvmPaths.SPIEGEL}`,
                label: <FormattedMessage id="avm.nav.spiegel" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.FORECAST}`,
                to: `${AppRoutes.avm}/${AvmPaths.FORECAST}`,
                label: <FormattedMessage id="avm.nav.forecast" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.INVENTORY}`,
                to: `${AppRoutes.avm}/${AvmPaths.INVENTORY}`,
                label: <FormattedMessage id="avm.nav.inventory" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.BATCHES}`,
                to: `${AppRoutes.avm}/${AvmPaths.BATCHES}`,
                label: <FormattedMessage id="avm.nav.batches" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.SETTINGS}`,
                to: `${AppRoutes.avm}/${AvmPaths.SETTINGS}`,
                label: <FormattedMessage id="app.titles.settings" />,
            },
            {
                key: `${AppRoutes.avm}/${AvmPaths.RECHENREGELN}`,
                to: `${AppRoutes.avm}/${AvmPaths.RECHENREGELN}`,
                label: <FormattedMessage id="avm.nav.rules" />,
            },
        ],
        [],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
